module.exports = __webpack_public_path__ + "static/phone-img-08a62ee60c2d3a00bded87c61d886d88.png";